/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Container, Row } from 'react-bootstrap';
function Certificates() {
  return (
    <section>
      <Container fluid className="home-section">
        <Container className="home-content">
          <Row>
            <h1 className=" purple">
              Work Permit in Japan as a Software Engineer{' '}
            </h1>
            <h2>
              <i>
                <b>Category : </b> Technology/Humanities/International Business
              </i>
            </h2>
            <h2>
              <i>
                <b>Organization : </b> Japan Government
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className=" purple">
              Information Technology Engineers Examination (ITEE)
            </h1>
            <h2>
              <i>
                <b>Examination Topic : </b> Programming Logic, Datastructure,
                Algorithm, Software design, Digital Logic design, Network,
                Security, Business Strategy and management.
              </i>
            </h2>
            <h2>
              <i>
                <b>Organized By : </b> Information Technology Promotion Agency
                (IPA) JAPAN
              </i>
            </h2>
            <h2>
              <i>
                <b>Status : </b> Passed
              </i>
            </h2>
            <h2>
              <i>
                <b>Passing Year : </b> December, 2018
              </i>
            </h2>
          </Row>
          <br />
          <br />

          <Row>
            <h1 className=" purple">Modern React with Redux</h1>
            <h2>
              <i>
                <b>Course Topic : </b> React, Redux(State Management Library)
              </i>
            </h2>
            <h2>
              <i>
                <b>Organized By : </b> Udemy
              </i>
            </h2>
            <h2>
              <i>
                <b>Instructor : </b>Stephen Grider
              </i>
            </h2>
            <h2>
              <i>
                <b>Status : </b> Completed
              </i>
            </h2>
            <h2>
              <i>
                <b>Passing Year : </b> January, 2023
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className=" purple">
              Test of English for International Communication (TOEIC)
            </h1>
            <h2>
              <i>
                <b>Topic : </b> English reading and Listening
              </i>
            </h2>
            <h2>
              <i>
                <b>Organized By : </b> Educational Testing Service(ETS)
              </i>
            </h2>
            <h2>
              <i>
                <b>Score : </b> 685 out of 990
              </i>
            </h2>
            <h2>
              <i>
                <b>Participating year : </b> September, 2023
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className=" purple">
              Japanese Language Proficiency Test (JLPT)
            </h1>
            <h2>
              <i>
                <b>Topic : </b> Japanese reading and Listening for Intermediate
                Level
              </i>
            </h2>
            <h2>
              <i>
                <b>Organized By : </b> Japan foundation
              </i>
            </h2>
            <h2>
              <i>
                <b>Status : </b> Passed
              </i>
            </h2>
            <h2>
              <i>
                <b>Passing year : </b> August, 2021
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className=" purple">Thinking in a Redux way</h1>
            <h2>
              <i>
                <b>Course Topic : </b> React, Redux(State Management Library)
              </i>
            </h2>
            <h2>
              <i>
                <b>Organized By : </b> Learn with sumit (LWS)
              </i>
            </h2>
            <h2>
              <i>
                <b>Instructor : </b>Sumit Saha
              </i>
            </h2>
            <h2>
              <i>
                <b>Status : </b> Completed
              </i>
            </h2>
            <h2>
              <i>
                <b>Passing Year : </b> April, 2023
              </i>
            </h2>
          </Row>
          <br />
          <br />

          <Row>
            <h1 className=" purple">Driving Licence </h1>
            <h2>
              <i>
                <b>Category : </b> Regular Vehicle with Automatic
                Transmission(AT), Scooter
              </i>
            </h2>
            <h2>
              <i>
                <b>Organization : </b> Japan Government
              </i>
            </h2>
            <h2>
              <i>
                <b>Status : </b> Blue Card
              </i>
            </h2>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Certificates;
